import { css } from 'lit';

export const instancesPageStyles = css`
  .toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-3);
    align-items: center;
    margin-bottom: var(--space-4);
  }

  /* On a phone the filters do not fit: the group scrolls sideways instead of running off the page. */
  .filters {
    display: inline-flex;
    max-width: 100%;
    border: var(--border-width) solid var(--border-strong);
    border-radius: var(--radius);
    overflow-x: auto;
    scrollbar-width: none;
  }

  .filters button {
    flex: none;
    border: none;
    border-radius: 0;
    background: transparent;
  }

  .filters button + button {
    border-left: var(--border-width) solid var(--border-strong);
  }

  .filters button[aria-pressed='true'] {
    background: var(--accent);
    color: var(--accent-text);
  }

  .toolbar input {
    max-width: var(--search-width);
  }

  .pending {
    color: var(--tone-progress);
    font-weight: var(--font-weight-semibold);
  }

  .arrow {
    color: var(--text-muted);
    padding: 0 var(--space-1);
  }
`;
